(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plugin-hero"] && !Shopify.designMode) return;
  try {
    
  const bootOneClickWheel = () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-oc-wheel]').forEach((stage) => {
      if (stage.dataset.ocReady === 'true') return;
      stage.dataset.ocReady = 'true';

      const tilt = stage.querySelector('[data-oc-tilt]');
      const hub = stage.querySelector('[data-oc-hub]');
      const note = stage.querySelector('[data-oc-note]');
      const logo = stage.querySelector('.oc-hub__logo');
      const version = stage.querySelector('.oc-hub__version');
      const ring = stage.querySelector('.oc-hub__ring');
      let idleNote = stage.dataset.idle || '';
      const pagePath = window.location.pathname;
      const pageLang = /^\/en(-[a-z]{2,})?(\/|$)/i.test(pagePath)
        ? 'en'
        : /^\/fr(-[a-z]{2,})?(\/|$)/i.test(pagePath)
          ? 'fr'
          : 'es';
      if (pageLang === 'en' || pageLang === 'fr') {
        const wheelCopy = {
          'Pasa el cursor. Así se abre dentro de After Effects.': 'Hover. This is how it opens inside After Effects.',
          'Vista previa de One Click': 'One Click preview',
          'Objeto Nulo': 'Null Object',
          'Crea un null sobre la selección.': 'Creates a null on the selection.',
          'Objeto Nulo. Crea un null sobre la selección.': 'Null Object. Creates a null on the selection.',
          'Cámaras': 'Cameras',
          'Crea una cámara. Afuera eliges un nodo, dos nodos o profundidad de campo.': 'Creates a camera. Outside you choose one node, two nodes, or depth of field.',
          'Cámaras. Crea una cámara. Afuera eliges un nodo, dos nodos o profundidad de campo.': 'Cameras. Creates a camera. Outside you choose one node, two nodes, or depth of field.',
          'Cámara de un nodo': 'One-node camera',
          'Cámara de dos nodos': 'Two-node camera',
          'Profundidad de campo': 'Depth of field',
          'Formas': 'Shapes',
          'Crea una forma. Afuera eliges rectángulo, elipse, polígono o estrella.': 'Creates a shape. Outside you choose rectangle, ellipse, polygon, or star.',
          'Formas. Crea una forma. Afuera eliges rectángulo, elipse, polígono o estrella.': 'Shapes. Creates a shape. Outside you choose rectangle, ellipse, polygon, or star.',
          'Rectángulo': 'Rectangle',
          'Rectángulo redondeado': 'Rounded rectangle',
          'Elipse': 'Ellipse',
          'Polígono': 'Polygon',
          'Estrella': 'Star',
          'Ajuste': 'Adjustment',
          'Crea un adjustment layer. Afuera guardas los efectos que más usas.': 'Creates an adjustment layer. Outside you save the effects you use most.',
          'Ajuste. Crea un adjustment layer. Afuera guardas los efectos que más usas.': 'Adjustment. Creates an adjustment layer. Outside you save the effects you use most.',
          'Espacio para un efecto': 'Slot for an effect',
          'Luces': 'Lights',
          'Crea una luz. Afuera eliges paralela, spot, punto o ambiente.': 'Creates a light. Outside you choose parallel, spot, point, or ambient.',
          'Luces. Crea una luz. Afuera eliges paralela, spot, punto o ambiente.': 'Lights. Creates a light. Outside you choose parallel, spot, point, or ambient.',
          'Luz paralela': 'Parallel light',
          'Luz spot': 'Spot light',
          'Luz de punto': 'Point light',
          'Luz ambiente': 'Ambient light',
          'Texto': 'Text',
          'Crea una capa de texto. Afuera eliges la fuente y el color.': 'Creates a text layer. Outside you choose the font and the color.',
          'Texto. Crea una capa de texto. Afuera eliges la fuente y el color.': 'Text. Creates a text layer. Outside you choose the font and the color.',
          'Espacio para una fuente': 'Slot for a font',
          'Color de relleno': 'Fill color',
          'Color del borde': 'Stroke color'
        };
        const swapWheel = (value) => (value && wheelCopy[value]) || value;
        idleNote = swapWheel(idleNote);
        stage.dataset.idle = idleNote;
        if (note) note.textContent = idleNote;
        stage.querySelectorAll('[data-label], [data-detail], [aria-label]').forEach((el) => {
          if (el.dataset.label) el.dataset.label = swapWheel(el.dataset.label);
          if (el.dataset.detail) el.dataset.detail = swapWheel(el.dataset.detail);
          const aria = el.getAttribute('aria-label');
          if (aria && wheelCopy[aria]) el.setAttribute('aria-label', wheelCopy[aria]);
        });
      }

      const setActive = (segment, button) => {
        stage.classList.add('is-hot');
        stage.querySelectorAll('.oc-seg').forEach((item) => {
          item.classList.toggle('is-active', item === segment);
        });
        if (hub && segment) {
          hub.textContent = segment.dataset.label || '';
          hub.style.fill = segment.dataset.color || '#f5f5f7';
        }
        if (logo) logo.style.opacity = '0';
        if (version) version.style.opacity = '0';
        if (ring && segment) ring.style.stroke = segment.dataset.color || '';
        stage.querySelectorAll('.oc-sub').forEach((sub) => {
          sub.setAttribute('aria-hidden', sub.parentElement === segment ? 'false' : 'true');
        });
        if (note) note.textContent = (button && button.dataset.detail) || (segment && segment.dataset.detail) || idleNote;
      };

      const reset = () => {
        stage.classList.remove('is-hot');
        stage.querySelectorAll('.oc-seg').forEach((item) => item.classList.remove('is-active'));
        if (tilt) tilt.style.transform = '';
        if (hub) {
          hub.textContent = '';
          hub.style.fill = 'transparent';
        }
        if (logo) logo.style.opacity = '';
        if (version) version.style.opacity = '';
        if (ring) ring.style.stroke = '';
        stage.querySelectorAll('.oc-sub').forEach((sub) => sub.setAttribute('aria-hidden', 'true'));
        if (note) note.textContent = idleNote;
      };

      let activeSegment = null;

      const nearOuterButtons = (event, segment) => {
        if (!segment) return false;
        const buttons = segment.querySelectorAll('.oc-sub__btn');
        for (const button of buttons) {
          const box = button.getBoundingClientRect();
          const dx = event.clientX - (box.left + box.width / 2);
          const dy = event.clientY - (box.top + box.height / 2);
          if (dx * dx + dy * dy < 120 * 120) return true;
        }
        return false;
      };

      const followPointer = (event) => {
        const segment = event.target.closest('.oc-seg');
        if (segment && stage.contains(segment)) {
          activeSegment = segment;
          setActive(segment, event.target.closest('.oc-sub__btn'));
          return;
        }
        if (activeSegment && nearOuterButtons(event, activeSegment)) return;
        if (!activeSegment) return;
        activeSegment = null;
        reset();
      };

      stage.addEventListener('pointermove', (event) => {
        if (tilt && !reduce && event.pointerType === 'mouse') {
          const box = stage.getBoundingClientRect();
          const x = (event.clientX - box.left) / box.width - 0.5;
          const y = (event.clientY - box.top) / box.height - 0.5;
          tilt.style.transform = 'rotateX(' + (-y * 10).toFixed(2) + 'deg) rotateY(' + (x * 12).toFixed(2) + 'deg)';
        }
        if (event.pointerType && event.pointerType !== 'mouse') return;
        followPointer(event);
      });

      stage.addEventListener('pointerleave', (event) => {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        const focused = document.activeElement;
        if (focused && stage.contains(focused) && typeof focused.blur === 'function') focused.blur();
        activeSegment = null;
        reset();
      });

      stage.addEventListener('pointerover', (event) => {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        followPointer(event);
      });

      if (window.matchMedia('(pointer: coarse)').matches) {
        stage.querySelectorAll('.oc-seg').forEach((segment) => segment.removeAttribute('tabindex'));
      }

      stage.addEventListener('pointerdown', (event) => {
        const segment = event.target.closest('.oc-seg');
        if (!segment || !stage.contains(segment)) return;
        const button = event.target.closest('.oc-sub__btn');
        if (event.pointerType !== 'mouse') {
          event.preventDefault();
          if (button && button.dataset.tool === 'camDoF') button.classList.toggle('is-on');
          setActive(segment, button);
          if (!button) {
            segment.classList.add('is-fired');
            window.setTimeout(() => segment.classList.remove('is-fired'), 400);
          }
          const focused = document.activeElement;
          if (focused && stage.contains(focused) && typeof focused.blur === 'function') focused.blur();
          return;
        }
        setActive(segment, button);
      });

      stage.addEventListener('click', (event) => {
        const button = event.target.closest('.oc-sub__btn');
        const segment = event.target.closest('.oc-seg');
        if (!segment || !stage.contains(segment)) return;
        if (button) {
          if (button.dataset.tool === 'camDoF') button.classList.toggle('is-on');
          setActive(segment, button);
          return;
        }
        setActive(segment);
        segment.classList.add('is-fired');
        window.setTimeout(() => segment.classList.remove('is-fired'), 400);
      });

      stage.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const button = event.target.closest('.oc-sub__btn');
        const segment = event.target.closest('.oc-seg');
        if (!segment || !stage.contains(segment)) return;
        event.preventDefault();
        if (button && button.dataset.tool === 'camDoF') button.classList.toggle('is-on');
        setActive(segment, button);
        if (!button) {
          segment.classList.add('is-fired');
          window.setTimeout(() => segment.classList.remove('is-fired'), 400);
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootOneClickWheel);
  } else {
    bootOneClickWheel();
  }

  document.addEventListener('shopify:section:load', bootOneClickWheel);

  const bootAtmosphere = () => {
    const sky = document.querySelector('.pl-atmosphere');
    if (!sky || sky.dataset.plSky === 'true') return;
    sky.dataset.plSky = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let frame = 0;
    const paint = () => {
      frame = 0;
      sky.style.setProperty('--pl-scroll', String(window.scrollY || 0));
    };

    window.addEventListener(
      'scroll',
      () => {
        if (frame) return;
        frame = window.requestAnimationFrame(paint);
      },
      { passive: true }
    );
    paint();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAtmosphere);
  } else {
    bootAtmosphere();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plugin-pricing"] && !Shopify.designMode) return;
  try {
    
  const bootLaunchDate = () => {
    const months = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ];
    const now = new Date();
    const label = `${now.getDate()} de ${months[now.getMonth()]}`;
    const iso = [
      now.getFullYear(),
      String(now.getMonth() + 1).padStart(2, '0'),
      String(now.getDate()).padStart(2, '0'),
    ].join('-');

    for (const node of document.querySelectorAll('[data-pl-today]')) {
      node.textContent = label;
      node.dateTime = iso;
    }
  };

  bootLaunchDate();
  document.addEventListener('shopify:section:load', bootLaunchDate);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plugin-steps"] && !Shopify.designMode) return;
  try {
    
  const bootPluginCycle = () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-pl-cycle]').forEach((slot) => {
      if (slot.dataset.plReady === 'true') return;
      slot.dataset.plReady = 'true';
      const rows = Array.from(slot.querySelectorAll('.pl-cycle__row'));
      if (rows.length < 2 || reduce) return;

      let index = 0;
      const timer = window.setInterval(() => {
        const current = rows[index];
        index = (index + 1) % rows.length;
        current.classList.remove('is-on');
        current.classList.add('is-out');
        rows[index].classList.remove('is-out');
        rows[index].classList.add('is-on');
        window.setTimeout(() => current.classList.remove('is-out'), 420);
      }, 1800);

      slot.dataset.plTimer = String(timer);
    });
  };

  document.addEventListener('shopify:section:unload', (event) => {
    const slot = event.target.querySelector('[data-pl-cycle]');
    if (!slot || !slot.dataset.plTimer) return;
    window.clearInterval(Number(slot.dataset.plTimer));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPluginCycle);
  } else {
    bootPluginCycle();
  }

  document.addEventListener('shopify:section:load', bootPluginCycle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["software-titles-landing"]) return;
  try {
    
  const bootSoftwareTitles = () => {
    document.querySelectorAll('.software-titles__word-window--images').forEach((slot) => {
      if (slot.dataset.animationReady === 'true') return;

      const words = [...slot.querySelectorAll('.software-titles__word')];
      if (words.length < 2) return;

      slot.dataset.animationReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const states = ['is-active', 'is-below', 'is-exiting', 'from-below'];
      let activeIndex = 0;
      let timer = null;
      let transitionTimer = null;
      let started = false;
      let observer = null;

      const setState = (word, ...nextStates) => {
        states.forEach((state) => {
          if (!nextStates.includes(state)) word.classList.remove(state);
        });
        nextStates.forEach((state) => word.classList.add(state));
      };

      words.forEach((word, index) => setState(word, index === 0 ? 'is-active' : 'is-below'));
      if (reducedMotion) return;

      const step = () => {
        const current = words[activeIndex];
        const nextIndex = (activeIndex + 1) % words.length;
        const next = words[nextIndex];

        setState(current, 'is-exiting');
        setState(next, 'is-active', 'from-below');
        window.clearTimeout(transitionTimer);
        transitionTimer = window.setTimeout(() => setState(current, 'is-below'), 680);
        activeIndex = nextIndex;
        timer = window.setTimeout(step, 1880);
      };

      const start = () => {
        if (timer || document.hidden) return;
        timer = window.setTimeout(() => {
          started = true;
          timer = null;
          step();
        }, started ? 1200 : 520);
      };

      const stop = () => {
        window.clearTimeout(timer);
        window.clearTimeout(transitionTimer);
        timer = null;
        transitionTimer = null;
      };

      const onVisibilityChange = () => document.hidden ? stop() : start();
      document.addEventListener('visibilitychange', onVisibilityChange);
      slot._softwareTitlesCleanup = () => {
        stop();
        observer?.disconnect();
        document.removeEventListener('visibilitychange', onVisibilityChange);
      };

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => entry.isIntersecting ? start() : stop());
        }, { threshold: 0 });
        observer.observe(slot);
      } else {
        start();
      }
    });
  };

  const stopSoftwareTitles = (event) => {
    event.target.querySelectorAll?.('.software-titles__word-window--images').forEach((slot) => {
      slot._softwareTitlesCleanup?.();
      delete slot._softwareTitlesCleanup;
      delete slot.dataset.animationReady;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSoftwareTitles);
  } else {
    bootSoftwareTitles();
  }

  document.addEventListener('shopify:section:unload', stopSoftwareTitles);
  document.addEventListener('shopify:section:load', bootSoftwareTitles);

  } catch(e) { console.error(e); }
})();
})();
